import { AbstractControl } from "@angular/forms";

export function documentValidator(control: AbstractControl): { invalidDocument: boolean } | null {
    const document = String(control.value)
        .replace(/[^a-zA-Z0-9]/g, "")
        .toUpperCase();

    if (!document) return null;

    if (document.length === 11) {
        return isCPFValid(document) ? null : { invalidDocument: true };
    } else if (document.length === 14) {
        return isCNPJValid(document) ? null : { invalidDocument: true };
    }

    return { invalidDocument: true };
}

export function isCPFValid(cpf: string): boolean {
    if (!/^\d{11}$/.test(cpf)) return false;
    if (/^(\d)\1{10}$/.test(cpf)) return false;

    let sum = 0;
    for (let i = 0; i < 9; i++) sum += parseInt(cpf.charAt(i)) * (10 - i);
    let digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    if (digit !== parseInt(cpf.charAt(9))) return false;

    sum = 0;
    for (let i = 0; i < 10; i++) sum += parseInt(cpf.charAt(i)) * (11 - i);
    digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    return digit === parseInt(cpf.charAt(10));
}

export function isCNPJValid(cnpj: string): boolean {
    const cleaned = cnpj.toUpperCase();
    const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    // CNPJ numérico: validar com DV
    if (/^\d{14}$/.test(cleaned)) {
        if (/^(\d)\1{13}$/.test(cleaned)) return false;
    }

    // CNPJ alfanumérico: validar formato
    if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cleaned)) return false;

    const firstDigit = calculateCnpjDigit(cleaned.slice(0, 12), weights1);
    const secondDigit = calculateCnpjDigit(`${cleaned.slice(0, 12)}${firstDigit}`, weights2);

    return `${firstDigit}${secondDigit}` === cleaned.slice(12);
}

function calculateCnpjDigit(document: string, weights: number[]): number {
    let sum = 0;
    for (let i = 0; i < document.length; i++) sum += getCnpjCharValue(document.charAt(i)) * weights[i];
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
}

function getCnpjCharValue(char: string): number {
    return char.charCodeAt(0) - 48;
}
